import styled from 'styled-components';

export const Title = styled.h2`
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 48px !important;
  line-height: 58px !important;
  text-align: center !important;
  color: #000000 !important;

  @media (max-width: 1200px){
      font-size: 38px !important;
      line-height: 58px !important;
  }
  @media (max-width: 992px){
    font-weight: 600 !important;
    font-size: 20px !important;
    line-height: 24px !important;
  }
  @media (max-width: 440px) {
      font-size: 18px !important;
      line-height: 35px !important;
  }
}
`;

export const Container = styled.div`
  max-width: 1480px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
`;
